import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import Slider from 'react-slick';

import useI18n from '../../../hooks/use-i18n';

import '../../../styles/campaign-slider-tw.scss';

const CampaignSliderTW = (props) => {
  const { setImageActive } = props;
  const i18n = useI18n();
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const referralSlider = useRef(null);

  const twCampaign = i18n.t('referrer.tw_campaign');

  const calculateTransform = (current, next, defaultValue, translationValue) => {
    const innerSliderListStyle = referralSlider.current.innerSlider.list.style;
    if (current === next) {
      innerSliderListStyle.transform = `translate3d(${defaultValue}px, 0, 0)`;
      innerSliderListStyle.transition = 'transform 500ms ease';
      return;
    }
    const isSwipeRight = next > current;
    const translateValue = isSwipeRight ? defaultValue + translationValue : defaultValue - translationValue;
    innerSliderListStyle.transform = `translate3d(${translateValue}px, 0, 0)`;
  };

  useEffect(() => {
    setIsMobile(window.innerWidth < 699.9);
  }, []);

  const referralSliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    beforeChange: (current, next) => {
      calculateTransform(current, next, 0, 114);
      setActiveSlide(next);
    },
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          adaptiveHeight: true,
          variableWidth: false,
          beforeChange: (current, next) => {
            calculateTransform(current, next, 0, 0);
            setActiveSlide(Math.ceil(next));
          }
        }
      }
    ]
  };

  return (
    <section className="referral-campaign-tw">
      <div className="referral-modes">
        <span
          role="presentation"
          onClick={() => { referralSlider.current.slickPrev(); }}
          className={activeSlide === 0 ? 'active' : ''}
          data-key="referrer::tw_campaign::card_one_heading"
          data-lokalise=""
        >
          {twCampaign.card_one_heading}
        </span>
        <span
          role="presentation"
          onClick={() => { referralSlider.current.slickNext(); }}
          className={activeSlide === 1 ? 'active' : ''}
          data-key="referrer::tw_campaign::card_two_heading"
          data-lokalise=""
        >
          {twCampaign.card_one_heading}
        </span>
      </div>
      <div className="referral-slider-container">
        <Slider {...referralSliderSettings} className="referral-cards-slider" ref={referralSlider}>
          <div className={`referral-card  ${activeSlide !== 0 ? 'inactive-slide' : ''}`}>
            <div className="referral-content">
              <h1
                className="card-one-main-heading"
                data-key="referrer::tw_campaign::card_one_content::card_heading"
                data-lokalise=""
              >
                {twCampaign.card_one_content.card_heading}
              </h1>
              <p
                className="card-one-content"
                data-key="referrer::tw_campaign::card_one_content::card_content_one"
                data-lokalise=""
              >
                {twCampaign.card_one_content.card_content_one}
              </p>
              <p
                className="card-one-sub-content"
                data-key="referrer::tw_campaign::card_one_content::card_content_two"
                data-lokalise=""
              >
                {twCampaign.card_one_content.card_content_two}
                &nbsp;*
                <a
                  data-key="referrer::tw_campaign::card_one_content::card_link_text"
                  data-lokalise=""
                  target="_blank"
                  href="https://www.zenyum.com/tw-zh/blog/zenyum%e5%b0%b1%e6%98%af%e6%83%b3%e5%b0%8d%e4%bd%a0%e5%a5%bd%ef%bc%81/"
                  rel="noreferrer"
                >
                  {twCampaign.card_one_content.card_link_text}
                </a>
              </p>
            </div>
            <div className="referral-banner-image">
              <div className="overlay" />
              <img
                data-gumlet="false"
                src={`/img/referrer/revamp/tw-campaign/campaign-image-0-${isMobile ? 'mobile' : 'desktop'}.png`}
                alt="referral-modes-new-friend"
                role="presentation"
                onClick={() => {
                  if (isMobile) {
                    setImageActive({ activeSlide: 0, isModalOpen: true });
                  }
                }}
              />
            </div>
          </div>
          <div className={`referral-card  ${activeSlide !== 1 ? 'inactive-slide' : ''}`}>
            <div className="referral-content">
              <h1
                className="card-two-main-heading"
                data-key="referrer::tw_campaign::card_two_content::card_heading"
                data-lokalise=""
              >
                {twCampaign.card_two_content.card_heading}
              </h1>
              <p
                className="card-two-content"
                data-key="referrer::tw_campaign::card_two_content::card_content_one"
                data-lokalise=""
              >
                {twCampaign.card_two_content.card_content_one}
                &nbsp;*

                <a
                  data-key="referrer::tw_campaign::card_two_content::card_link_text"
                  data-lokalise=""
                  target="_blank"
                  href="https://www.zenyum.com/tw-zh/blog/zenyum%e5%b0%b1%e6%98%af%e6%83%b3%e5%b0%8d%e4%bd%a0%e5%a5%bd%ef%bc%81/"
                  rel="noreferrer"
                >
                  {twCampaign.card_two_content.card_link_text}
                </a>
              </p>
            </div>
            <div className="referral-banner-image">
              <div className="overlay" />
              <img
                data-gumlet="false"
                src={`/img/referrer/revamp/tw-campaign/campaign-image-1-${isMobile ? 'mobile' : 'desktop'}.png`}
                alt="referral-modes-old-friend"
                role="presentation"
                onClick={() => {
                  if (isMobile) {
                    setImageActive({ activeSlide: 1, isModalOpen: true });
                  }
                }}
              />
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default CampaignSliderTW;

CampaignSliderTW.propTypes = {
  setImageActive: PropTypes.func.isRequired
};
